/**
 * Activtiy Logging Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateActivityLogClient } from './updateActivityLogClient';
import { UpdateActivityLogSecurity } from './updateActivityLogSecurity';


export interface UpdateActivityLog { 
    id?: string | null;
    client?: UpdateActivityLogClient;
    security?: UpdateActivityLogSecurity;
}

